module.exports = __webpack_public_path__ + "static/media/info-blue-icon.7c76f911.svg";